import { Flex, theme, Typography } from '@styles';
import { bool, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { tooltipLayoutByVariant } from './ActivityTooltip.layoutProps';

const ActivityTooltip = ({ isVisible, variant }) => {
  const { i18n } = useTranslation();

  const contentLayout = tooltipLayoutByVariant[variant];

  if (!isVisible) {
    return null;
  }

  return (
    <Flex
      backgroundColor={theme.colors.background}
      flexDirection="column"
      gap={24}
      p={16}
      position="absolute"
      right={0}
      top={48}
      width={350}
      zIndex={3}
    >
      <Typography color={theme.colors.white[100]} variant="MS-bold-s16-lh25">
        {i18n.t(contentLayout.titleText).toUpperCase()}
      </Typography>
      {contentLayout.subtitleText && (
        <Typography
          color={theme.colors.white[100]}
          variant="MS-regular-s14-lh22"
        >
          {i18n.t(contentLayout.subtitleText)}
        </Typography>
      )}
      <Typography color={theme.colors.white[60]} variant="MS-regular-s14-lh22">
        {i18n.t(contentLayout.content)}
      </Typography>
    </Flex>
  );
};

ActivityTooltip.propTypes = {
  isVisible: bool.isRequired,
  variant: string.isRequired,
};

export default ActivityTooltip;
